import { textEllipsis } from '@design-system/styles'
import { css } from '@emotion/react'
import { typo } from '@mathflat/common/style'

import { DROPDOWN_DEFAULT_BUTTON_CONTENTS_CLASSNAME } from '@/component/molecules/Dropdown/Dropdown'

const S = {
  StudentNameBox: css`
    display: flex;
    flex-direction: column;

    margin-bottom: 24px;
    padding: 16px;
    border: 1px solid var(--Colors-Gray-300);
    border-radius: var(--Radius-200);

    background: #fff;

    .error > button {
      border: 1px solid var(--Colors-Red-500);
    }

    .error-message {
      color: var(--Colors-Red-500);
      ${typo.caption01};
      margin-top: 4px;
    }
  `,
  StudentNameHeader: css`
    display: flex;
    gap: 24px;
    align-items: center;

    > .title {
      display: flex;
      flex-direction: column;

      font-weight: 700;
      ${typo.body02};

      > span {
        width: 107px;
      }

      > .count {
        color: var(--Colors-Gray-600);
        font-weight: 400;
        ${typo.caption01};
      }
    }

    > .radio-group {
      display: flex;
      gap: 24px;

      label {
        height: 21px;
      }
    }
  `,

  StudentNameDivider: css`
    width: 100%;
    height: 1px;
    background: var(--Colors-Gray-300);
    margin: 16px 0 18px 0;
    border: none;
  `,

  StudentNameSelectRow: css`
    display: flex;
    align-items: center;
    gap: 8px;

    .dropdown {
      width: 320px;
      min-width: 200px;
      max-width: 360px;
    }

    .${DROPDOWN_DEFAULT_BUTTON_CONTENTS_CLASSNAME} .dropdown-item-children {
      > p {
        ${textEllipsis(1)};
      }

      .dropdown-item-badge {
        display: none;
      }
    }
  `,

  DropdownItemChildren: css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 4px;
    flex: 1;

    > p {
      flex: 1;
      ${textEllipsis(2)};
    }
  `,

  StudentNameDesc: css`
    margin-top: 8px;

    text-align: center;
    color: var(--Colors-Gray-600);
    ${typo.caption01};
  `,
}

export default S
